import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/work_orders',
    name: 'WorkOrder',
    component: {
      name: 'AdminWorkOrder',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'work_order',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminWorkOrderIndex',
        component: () => import('../views/admin/WorkOrderAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminWorkOrderNew',
        component: () => import('../views/admin/WorkOrderAdminNew.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminWorkOrderIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminWorkOrderShow',
        component: () => import('../views/admin/WorkOrderAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminWorkOrderIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminWorkOrderDetails',
            component: () => import('../views/admin/WorkOrderAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminWorkOrderIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminWorkOrderEdit',
            component: () => import('../views/admin/WorkOrderAdminEdit.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminWorkOrderDetails' },
            },
          },
          {
            path: 'phases',
            name: 'AdminWorkOrderPhases',
            component: () => import('../views/admin/WorkOrderAdminPhases.vue'),
            meta: {
              backRoute: { name: 'AdminWorkOrderIndex' },
              resource: 'phase',
            },
          },
          {
            path: 'logs',
            name: 'AdminWorkOrderLogs',
            component: () => import('../views/admin/WorkOrderAdminLogs.vue'),
            meta: {
              backRoute: { name: 'AdminWorkOrderIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ]
  },
  {
    path: 'user/work_orders',
    name: 'UserWorkOrder',
    component: {
      name: 'UserWorkOrder',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'work_order',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'UserWorkOrderIndex',
        component: () => import('../views/user/WorkOrderUserIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'UserWorkOrderNew',
        component: () => import('../views/user/WorkOrderUserNew.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'UserWorkOrderIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'UserWorkOrderShow',
        component: () => import('../views/user/WorkOrderUserShow.vue'),
        meta: {
          backRoute: {
            name: 'UserWorkOrderIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'UserWorkOrderDetails',
            component: () => import('../views/user/WorkOrderUserDetails.vue'),
            meta: {
              backRoute: { name: 'UserWorkOrderIndex' },
            },
          },
          {
            path: 'edit',
            name: 'UserWorkOrderEdit',
            component: () => import('../views/user/WorkOrderUserEdit.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'UserWorkOrderDetails' },
            },
          },
        ],
      },
    ]
  },
  {
    path: 'admin/missing_work_orders',
    name: 'MissingWorkOrder',
    component: {
      name: 'AdminMissingWorkOrder',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'missing_work_order',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminMissingWorkOrderIndex',
        component: () => import('../views/admin/MissingWorkOrderAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
    ],
  },
  {
    path: 'user/missing_work_orders',
    name: 'UserMissingWorkOrder',
    component: {
      name: 'MissingWorkOrderUser',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'missing_work_order',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'UserMissingWorkOrderIndex',
        component: () => import('../views/user/MissingWorkOrderUserIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
    ],
  },
];

const pubRoutes = [
  {
    path: '/public/work_orders',
    name: 'PublicWorkOrder',
    component: {
      name: 'PublicWorkOrder',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'work_order',
      layout: 'Public',
      publicRoute: true,
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: ':id(\\d+)',
        name: 'PublicWorkOrderShow',
        component: () => import('../views/public/WorkOrderPublicShow.vue'),
        meta: {
          layout: 'Public',
          publicRoute: true,
        },
      }
    ],
  },
];


OCRoutes.forEach(route => router.addRoute('OC', route));
pubRoutes.forEach(route => router.addRoute(route));